import { PageHeader } from '../../components/PageHeader';
import { useTranslation } from '../../i18n/I18nProvider';
import { WeeklySummarySection } from './WeeklySummarySection';

/**
 * Vlastita ruta za tjedni sažetak. Obavijest `weekly_summary` vodi na `/napredak`,
 * gdje sažetak stoji na vrhu; `/sazetak` je isti sadržaj bez ostatka ekrana —
 * dovoljno za dijeljenje linka i za povratak iz emaila.
 */
export function WeeklySummary() {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader eyebrow={t('portal.progress')} title={t('summary.title')} subtitle={t('summary.subtitle')} />
      <WeeklySummarySection />
    </>
  );
}
